import {http} from '../../shared/services';

export const VERIFY_ACCOUNT_ACTIVATION_TOKEN = 'VERIFY_ACCOUNT_ACTIVATION_TOKEN';
export const VERIFY_ACCOUNT_ACTIVATION_TOKEN_PENDING = `${VERIFY_ACCOUNT_ACTIVATION_TOKEN}_PENDING`;
export const VERIFY_ACCOUNT_ACTIVATION_TOKEN_REJECTED = `${VERIFY_ACCOUNT_ACTIVATION_TOKEN}_REJECTED`;

export function verifyAccountActivationToken(userId, accountActivationToken) {
  return {
    type: VERIFY_ACCOUNT_ACTIVATION_TOKEN,
    payload: http.post(`user_account_activation/${userId}`, {'token': accountActivationToken}),
  };
}



// WEBPACK FOOTER //
// ./app/features/authentication/actions/verifyAccountActivationToken.js